<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 14" aria-hidden="true" focusable="false">
  <path fill="#000" fill-rule="evenodd" d="M12 5l-8 8-4-4 1.5-1.5L4 10l6.5-6.5z"></path>
</svg>
